module.exports = __webpack_public_path__ + "static/media/546.c824bc19.webp";